import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  private titleChangeSource = new Subject<PageModel>();
  private codeCardSource = new Subject<boolean>();
  isTitleChanged = this.titleChangeSource.asObservable();
  isCodeCardShown = this.codeCardSource.asObservable();

  showCodeCard(show: boolean = true) {
    this.codeCardSource.next(show);
  }

  setTitle(pageModel: PageModel) {
    this.titleChangeSource.next(pageModel);
  }
}

export interface PageModel {
  title: string;
  theme: themeEnum;
}

export enum themeEnum {
  halo = 'bc-yellow-text',
  zombie = 'bc-blue-text',
  green = 'bc-green-text',
  red = 'bc-red-text',
  orange = 'bc-orange-text',
}

export enum boostThemeEnum {
  none = 'transparent',
  springleaf = 'springleaf',
  wildhare = 'wild-hare',
  glacier = 'glacier',
  beautyberry = 'beautyberry',
  riverbed = 'riverbed',
  sunbeam = 'sunbeam',
  forestpath = 'forest-path',
  lupine = 'lupine',
  campfire = 'campfire',
  starlight = 'starlight',
  feelings = 'feelings',
  noveltyplay = 'noveltyplay',
  body = 'body',
  evergreen = 'evergreen',
  parchment = 'parchment',
}
